import React, { useState } from 'react';
import { useRouter } from 'next/router'
import { useSelector, useDispatch } from "react-redux";
import Link from 'next/link';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { userType } from "../components/global";
import HeadContent from '../components/HeadContent';
import FacebookLogin from 'react-facebook-login';
import { loginType, socialLoginClientId } from "../components/global";
import { login_details } from "../redux/actions/userAction";
import { signIn, useSession } from 'next-auth/client';
import { absoluteUrl } from '../components/getAbsoluteUrl';


export default function join() {
    const [session, loading] = useSession()
    const router = useRouter();
    const logindata = useSelector((state) => state.user);
    var islogged = logindata.islogged;
    if (islogged) {
        router.replace("/");
    }
    const [btn, setbtn] = useState('JOIN');
    const [passowrdError, setPassowrdError] = useState()
    const [isPasswordShown1, setIsPasswordShown1] = useState(false)
    const [isPasswordShown, setIsPasswordShown] = useState(false)
    const [userRegistration, setuserRegistration] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        cpassword: "",
        isInstitute: "",
        instituteCode: ""
    });

    const handleInput = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setuserRegistration({ ...userRegistration, [name]: value })
    }

    const togglePassword = () => {
        if (isPasswordShown1) {
            setIsPasswordShown1(false)
        } else {
            setIsPasswordShown1(true)
        }
    }

    const toggleConfirmPassword = () => {
        if (isPasswordShown) {
            setIsPasswordShown(false)
        } else {
            setIsPasswordShown(true)
        }
    }
    const dispatch = useDispatch();
    const responseFacebook = (response) => {
        if (response.status != "unknown") {
            var firstName = response.name.split(' ').slice(0, -1).join(' ');
            var lastName = response.name.split(' ').slice(-1).join(' ');
            setbtn('Wait...');
            try {
                dispatch(login_details({ firstName: firstName, lastName: lastName, email: response.email, socialLoginId: response.id, profileImage: response?.picture?.data?.url, loginType: loginType.facebook }));
            } catch (error) {
                setbtn('SIGN IN');
                toast.error("Something wrong! Please try again later", { position: "top-center" });
            }
        }
    }

    if (session && session.user) {
        let firstName = session.user.name.split(' ').slice(0, -1).join(' ');
        let lastName = session.user.name.split(' ').slice(-1).join(' ');
        dispatch(login_details({ email: session.user.email, firstName: firstName, lastName: lastName, profileImage: session.user.image, loginType: loginType.google }));
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (userRegistration.password != userRegistration.cpassword) {
            setPassowrdError(" Password doesn't match")
        } else {
            setbtn('Wait...');
            let user = {
                firstName: userRegistration.firstName.trim(),
                lastName: userRegistration.lastName.trim(),
                email: userRegistration.email.toLowerCase().trim(),
                password: userRegistration.password.trim(),
                isInstitute: userRegistration.isInstitute,
                userType: userType.teacher,
                loginType: loginType.email,
            }

            let response = await fetch(`/api/auth/register?instituteCode=${userRegistration.instituteCode}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(user)
            });
            if (response.status >= 200 && response.status < 300) {
                let rsp = await response.json();
                setbtn('JOIN');
                if (rsp.success) {
                    setuserRegistration({
                        firstName: "",
                        lastName: "",
                        email: "",
                        password: "",
                        cpassword: "",
                        isInstitute: "",
                        instituteCode: ""
                    })
                    toast.success(rsp.message, { position: "top-center" });
                    if (rsp.user.isEmailverified == true) {
                        setTimeout(() => {
                            router.replace('/login');
                        }, 6000);
                    } else {
                        setTimeout(() => {
                            router.replace('/login?register=success');
                        }, 6000);
                    }

                } else {
                    toast.warning(rsp.message, { position: "top-center" });
                }
            } else {
                setbtn('JOIN');
                toast.error("Something wrong! Please try again.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    return (
        <>
            <HeadContent title={'Join'} isBusyLoader={true} isMeta={true} />
            {!islogged ?
                <div className="page-wrapper">
                    <div className="page-content">
                        <div className="container">
                            <div className="login-wrap">
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "30px" }}>
                                    <img alt="yam" src="images/logo.png" style={{ width: "80%", height: "150px" }} />
                                </div>
                                {/* <img className="login-logo" alt="yam" src="images/logo.png" /> */}
                                <div className="login-content">
                                    <div className="login-logo">
                                        <h2>Join Yam</h2>
                                    </div>
                                    <div className="login-form">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label>First Name</label>
                                                <input className="au-input au-input--full" type="text" name="firstName" placeholder="First Name" value={userRegistration.firstName} onChange={handleInput} required />
                                            </div>
                                            <div className="form-group">
                                                <label>Last Name</label>
                                                <input className="au-input au-input--full" type="text" name="lastName" placeholder="Last Name" value={userRegistration.lastName} onChange={handleInput} required />
                                            </div>
                                            <div className="form-group">
                                                <label>Email Address</label>
                                                <input className="au-input au-input--full" type="email" name="email" placeholder="Email" value={userRegistration.email} onChange={handleInput} required />
                                            </div>
                                            <div className="form-group">
                                                <label>Password</label>
                                                <input className="au-input au-input--full" type={isPasswordShown1 ? "text" : "password"} name="password" placeholder="Password" value={userRegistration.password} onChange={handleInput} minLength="5" required />
                                                <i className="fa fa-eye password-icon" onClick={togglePassword} />
                                            </div>
                                            <div className="form-group">
                                                <label>Confirm Password</label>
                                                <input className="au-input au-input--full" type={isPasswordShown ? "text" : "password"} name="cpassword" placeholder="Confirm Password" value={userRegistration.cpassword} onChange={handleInput} minLength="5" required />
                                                <i className="fa fa-eye password-icon" onClick={toggleConfirmPassword} />
                                                <small className="text-danger"> {passowrdError} </small>
                                            </div>
                                            <div className="form-group">
                                                <label className="form-label">Individual/Institute </label>
                                                <select className="form-control" name="isInstitute" value={userRegistration.isInstitute} onChange={handleInput} tabIndex="-98" required>
                                                    <option key={0} value="">Select Individual/Institute</option>
                                                    <option key={1} value="false">Individual</option>
                                                    <option key={2} value="true">Institute</option>
                                                </select>
                                            </div>
                                            {userRegistration.isInstitute == "true" || userRegistration.isInstitute == true ?
                                                <div className="form-group">
                                                    <label>Enter Institute code</label>
                                                    <input className="au-input au-input--full" type="text" name="instituteCode" placeholder="Enter your institute code" value={userRegistration.instituteCode} onChange={handleInput} maxLength="6" required />
                                                </div>
                                                : null}

                                            <button type="submit" className="au-btn au-btn--block au-btn--green m-b-20 text-center">{btn}</button>
                                            <FacebookLogin
                                                appId={socialLoginClientId.facebook_client_id}
                                                autoLoad={false}
                                                fields="name,email,picture"
                                                callback={responseFacebook}
                                                cssClass="au-btn au-btn--block au-btn--facebook m-b-20 text-center"
                                                icon="fa-facebook"
                                                textButton=" Sign up with Facebook"
                                            >
                                            </FacebookLogin>
                                            <a className="au-btn--block m-b-20 text-center" id="googlebtn" onClick={(e) => { signIn("google"); }}><i className="fab fa-google"></i> &nbsp;SIGN UP WITH GOOGLE</a>
                                            <div className="login-checkbox">
                                                <label>
                                                    <Link href="/login">
                                                        <a>Login</a>
                                                    </Link>
                                                </label>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
            <ToastContainer />
        </>
    );
}

